import { useCallback } from "react";
import StatusBar16ProMax from "../components/StatusBar16ProMax";
import { useNavigate } from "react-router-dom";
import HomeIndicator from "../components/HomeIndicator";
import FrameComponent4 from "../components/FrameComponent4";

const Term = () => {
  const navigate = useNavigate();

  const onSaTiKhonClick = useCallback(() => {
    navigate("/31-sign-in1");
  }, [navigate]);

  return (
    <div className="w-full relative bg-light-primary-key-background flex flex-col items-start justify-start pt-0 px-0 pb-[111px] box-border gap-[59px] leading-[normal] tracking-[normal] text-left text-base text-light-text font-text-regular-lowercase">
      {/* <StatusBar16ProMax
        statusBar16ProMaxBackgroundColor="#fff"
        statusBar16ProMaxPosition="unset"
        statusBar16ProMaxTop="unset"
        statusBar16ProMaxLeft="unset"
      /> */}
      <div className="flex flex-row items-start justify-start pt-0 px-10 pb-2 box-border max-w-full">
        <div className="flex flex-col items-start justify-start gap-10 mq330:gap-5">
          <div
            className="relative font-medium whitespace-pre-wrap cursor-pointer"
            onClick={onSaTiKhonClick}
          >{`<  Sửa tài khoản`}</div>
          <div className="flex flex-col items-start justify-start gap-[15px] text-21xl text-dark-text">
            <h1 className="m-0 relative text-inherit font-semibold font-[inherit]">
              Điều khoản
            </h1>
            <h3 className="m-0 relative text-5xl font-semibold font-[inherit] text-light-text">
              Đọc kĩ trước khi cập nhập
            </h3>
          </div>
        </div>
      </div>
      <main className="self-stretch h-[1567px] relative">
        <section className="absolute top-[0px] left-[40px] text-base leading-[140%] text-dark-text text-left inline-block w-[362px] font-text-regular-lowercase">
          <p className="m-0 font-medium">
            Chào mừng bạn đến với GiGi – ứng dụng tương tác và điều khiển robot
            trò chuyện thông minh hoạt động trong thế giới thực. Vui lòng đọc kỹ
            các Điều Khoản Sử Dụng dưới đây trước khi sử dụng sản phẩm của chúng
            tôi.
          </p>
          <p className="m-0 font-medium">&nbsp;</p>
          <p className="m-0 font-semibold">1. Giới thiệu về GiGi</p>
          <p className="m-0 font-medium">
            GiGi là một robot trò chuyện thông minh (chatbot) được tích hợp trí
            tuệ nhân tạo, có thể tương tác bằng giọng nói hoặc văn bản, và hoạt
            động trực tiếp ngoài đời thật thông qua hệ thống điều khiển từ ứng
            dụng này. Ứng dụng giúp bạn giao tiếp, điều khiển, lập trình hành vi
            và theo dõi hoạt động của robot GiGi.
          </p>
          <p className="m-0 font-medium">&nbsp;</p>
          <p className="m-0 font-semibold">2. Chấp thuận điều khoản</p>
          <p className="m-0 font-medium">
            Khi sử dụng ứng dụng GiGi, bạn đồng ý với tất cả các điều khoản được
            nêu tại đây. Nếu bạn không đồng ý với bất kỳ phần nào của điều
            khoản, vui lòng ngừng sử dụng sản phẩm ngay lập tức.
          </p>
          <p className="m-0 font-medium">&nbsp;</p>
          <p className="m-0 font-semibold">3. Quyền sở hữu trí tuệ</p>
          <ul className="m-0 text-inherit pl-[21px]">
            <li className="mb-0">
              <span className="font-medium">
                Mọi nội dung, dữ liệu, mã nguồn, thiết kế, và tính năng trong
                ứng dụng và robot GiGi đều thuộc quyền sở hữu của [Tên công ty
                hoặc nhà phát triển].
              </span>
            </li>
            <li className="mb-0">
              <span className="font-medium">
                Người dùng không được sao chép, sửa đổi, phân phối lại hoặc sử
                dụng trái phép bất kỳ phần nào của sản phẩm.
              </span>
            </li>
          </ul>
          <p className="m-0 font-medium">&nbsp;</p>
          <p className="m-0 font-semibold">4. Quy định sử dụng</p>
          <p className="m-0 font-medium">Người dùng cam kết:</p>
          <ul className="m-0 text-inherit pl-[21px]">
            <li className="mb-0">
              <span className="font-medium">
                Không sử dụng GiGi vào các mục đích vi phạm pháp luật, đạo đức
                xã hội, hoặc gây hại cho cá nhân/tổ chức khác.
              </span>
            </li>
            <li className="mb-0">
              <span className="font-medium">
                Không can thiệp, hack, hoặc khai thác lỗ hổng của hệ thống robot
                hoặc ứng dụng.
              </span>
            </li>
            <li className="mb-0">
              <span className="font-medium">
                Không lập trình robot GiGi để thực hiện hành vi nguy hiểm, đe
                dọa, theo dõi trái phép hoặc phá hoại tài sản.
              </span>
            </li>
          </ul>
          <p className="m-0 font-medium">&nbsp;</p>
          <p className="m-0 font-semibold">5. Trách nhiệm và giới hạn</p>
          <ul className="m-0 text-inherit pl-[21px]">
            <li className="mb-0">
              <span className="font-medium">
                Chúng tôi không chịu trách nhiệm với bất kỳ thiệt hại trực tiếp
                hoặc gián tiếp nào phát sinh từ việc sử dụng GiGi sai cách hoặc
                không đúng hướng dẫn.
              </span>
            </li>
            <li className="mb-0">
              <span className="font-medium">
                Robot GiGi chỉ nên được sử dụng trong môi trường an toàn, có
                kiểm soát và được người trưởng thành giám sát nếu người sử dụng
                là trẻ vị thành niên.
              </span>
            </li>
          </ul>
          <p className="m-0 font-medium">&nbsp;</p>
          <p className="m-0 font-semibold">6. Cập nhật và thay đổi</p>
          <p className="m-0 font-medium">
            Chúng tôi có quyền thay đổi nội dung Điều Khoản Sử Dụng bất kỳ lúc
            nào. Những thay đổi sẽ được thông báo thông qua ứng dụng hoặc email
            đăng ký. Việc tiếp tục sử dụng GiGi sau khi điều khoản được cập nhật
            đồng nghĩa với việc bạn đã chấp nhận các thay đổi đó.
          </p>
          <p className="m-0 font-medium">&nbsp;</p>
          <p className="m-0 font-semibold">7. Liên hệ</p>
          <p className="m-0 font-medium">
            Mọi thắc mắc hoặc yêu cầu hỗ trợ vui lòng liên hệ qua:
          </p>
          <ul className="m-0 text-inherit pl-[21px]">
            <li className="mb-0">
              <span className="font-medium">{`Email: `}</span>
            </li>
            <li className="mb-0">
              <span className="font-medium">{`Website: `}</span>
            </li>
            <li className="mb-0">
              <span className="font-medium">{`Hotline: `}</span>
            </li>
          </ul>
          <p className="m-0 font-medium">&nbsp;</p>
          <p className="m-0 font-medium">
            Cảm ơn bạn đã tin tưởng và sử dụng GiGi – người bạn trò chuyện thông
            minh và đáng yêu của bạn trong đời sống hằng ngày!
          </p>
        </section>
        {/* <HomeIndicator
          homeIndicatorBackgroundColor="#fff"
          homeIndicatorMargin="unset"
          homeIndicatorPosition="absolute"
          homeIndicatorRight="unset"
          homeIndicatorBottom="unset"
          homeIndicatorLeft="0px"
          homeIndicatorTop="587px"
          homeIndicatorMarginTop="unset"
        /> */}
      </main>
      <FrameComponent4
        groupDivPadding="20px 27px"
        tiCKVNgViIuKh="Tôi đã đọc kỹ và đồng ý với điều khoản"
        tiCWidth="306px"
        tiCDisplay="inline-block"
      />
    </div>
  );
};

export default Term;
